export default "__VITE_ASSET__D1Xyy5CM__"